import { encryptInteger } from "@/Utils/encryptInteger";
import { useRouter } from "next/router";
import Slider from "react-slick";
import { formatMonthDayYear } from "@/Utils/dateFormat";
import Link from "next/link";

export default function ShowDetailSlider({ data }) {
  const router = useRouter();
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4.5,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <NextArrow />,
    responsive: [
      {
        breakpoint: 1124,
        settings: {
          slidesToShow: 3.5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2.2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 567,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const slugify = (str) =>
    str
      ?.toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/(^-|-$)/g, "");

  return (
    <div className=" w-full overflow-hidden ">
      <Slider {...settings} className="relative">
        {data &&
          data.length > 0 &&
          data.map((show, i) => {
            const city = slugify(show?.venue?.city);
            const state = slugify(show?.venue?.state);
            const showName = slugify(show?.name);
            const venueName = slugify(show?.venue?.name);
            const showDate = show?.show_date;

            const fullPath = `/shows/${city}-${state}/${show.id}-for-${showName}-at-${venueName}-on-${showDate}`;
            return (
              <Link
                href={{
                  pathname: fullPath,
                  query: { id: show?.id },
                }}
                as={fullPath}
                key={i}
                className="pr-4 cursor-pointer focus-visible:outline-none lg:pr-[28px] "
              >
                <img
                  className=" aspect-[1.53/1] lg:aspect-[0.94/1] rounded-2xl w-full h-full object-cover "
                  src={show.banner}
                  alt=""
                />
                <div className="">
                  <div className="text-base font-[700] leading-[24px] py-3">
                    {show.name}
                  </div>
                  <div className="text-sm font-[600] leading-[20px]  ">
                    {show?.show_date ? formatMonthDayYear(show.show_date) : ""}{" "}
                    <span className=" text-[#78828A]  ">
                      | {show.venue?.city}, {show.venue?.state}
                    </span>
                  </div>
                </div>
              </Link>
            );
          })}
      </Slider>
    </div>
  );
}

const NextArrow = (props) => {
  const { onClick } = props;
  return (
    <div
      className="slider_custom_next_arrow_shadow w-[161px] h-full flex items-center justify-end top-[0%]"
      onClick={onClick}
    >
      <div className="">
        <div className="slider_custom_next_arrow">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.42467 17.225C7.26634 17.225 7.10801 17.1667 6.98301 17.0417C6.74134 16.8 6.74134 16.4 6.98301 16.1583L12.4163 10.725C12.8163 10.325 12.8163 9.67502 12.4163 9.27502L6.98301 3.84168C6.74134 3.60002 6.74134 3.20002 6.98301 2.95835C7.22467 2.71668 7.62467 2.71668 7.86634 2.95835L13.2997 8.39168C13.7247 8.81668 13.9663 9.39168 13.9663 10C13.9663 10.6083 13.733 11.1833 13.2997 11.6083L7.86634 17.0417C7.74134 17.1583 7.58301 17.225 7.42467 17.225Z"
              fill="#F9F9F9"
            />
          </svg>
        </div>
      </div>
    </div>
  );
};
